module.exports = __webpack_public_path__ + "img/founder_hiroki.9d5c6e30.jpg";